import {geoPath, geoMercator} from 'd3-geo';
import { select, pointer } from 'd3-selection';

const d3 = {
	geoMercator,
	geoPath,
	select, 
	pointer
}

import BaseChart from './base.chart';

// import './scss/index.scss'

let chartName = 'knd-map';

class Chart extends BaseChart {
	setup() {
		this.projection = d3.geoMercator();
		this.path = d3.geoPath()
	}

	draw() {
		this.drawSvg(chartName);
		this.drawContainer();
		this.setupPath();
	}

	drawContainer() {
		this.gContainer = this.g.append('g');

		this.gPaths = this.gContainer.append('g')
			.attr('class', 'g-path')
	} 

	updateScales() {
		this.projection
			.fitSize([this.width(), this.height()], this.data());

		this.path.projection(this.projection);
	}

	update() {
		this.updateScales();
		this.updateChart();
	}

	setupPath() {
		this.areas = this.gPaths.selectAll('path')
			.data(this.data().features)

		this.area = this.areas.join('path')
			.attr('class', d => {
				let c = this._classNames(d);
				return `map-path ${c}`;
			})
			// .attr('fill', d => {
			// 	let c = this._classNames(d);
			// 	let color;
			// 	color = c.indexOf('knd-onderzoek') > 0 ? '#E2FFA0' : color;
			// 	color = c.indexOf('knd-afwezig') > 0 ? '#EFEDE8' : color;
			// 	color = c.indexOf('knd-afgerond') > 0 ? '#00D6AA' : color;
			// 	color = c.indexOf('knd-geen-onderzoek') > 0 ? '#FF5262' : color;

			// 	return color;
			// })

		if(this.onMouseOver()) {
			this.area.on('mouseover', (event,d) => this.onSelected(event, d))
		}

		if(this.onMouseOut()) {
			this.area.on('mouseout', d => {
				this._onMouseOut();
			})
		}
	}

	onSelected(event, item) {
		let d = item.properties;

		let container = d3.select('.container-map');
		const [mouseX, mouseY] = d3.pointer(event, container.node());

		this._onMouseOver(d, {mouseX, mouseY});

		this.gContainer.classed('highlight-selection', false);
	}

	setItemActive(selector) {
		this.gContainer.selectAll('.active')
			.classed('active', false);

		let selected = this.gContainer.select(selector)
			.classed('active', true);

		let d = selected.datum().properties;
		let centroid = this.path.centroid(selected.datum());
		this._onMouseOver(d, {mouseX: centroid[0], mouseY:centroid[1]});

		this.gContainer.classed('highlight-selection', true);
	}

	updateChart() {
		this.area
			.attr('d', this.path)
	}

	render() {
		this.setResponsive();

		this.setup();
		this.draw();
		this.update();

		return this;
	}

	resizeChart() {
		this.update();
	}

	onMouseOver(cb) {
		if (!arguments.length) return this._onMouseOver;
		this._onMouseOver = cb;
		return this;
	}

	onMouseOut(cb) {
		if (!arguments.length) return this._onMouseOut;
		this._onMouseOut = cb;
		return this;
	}

	classNames(cb) {
		if (!arguments.length) return this._classNames;
		this._classNames = cb;
		return this;
	}			
}

export default Chart;